import React, { FC, useEffect, useState } from "react";
import "./leaderboard.scss";
import RankBoard from "./RankBoard";
import CurrentStudentRank from "./CurrentStudentRank";
import PointsHistory from "./PointsHistory";
import { useLocation } from "react-router-dom";
import { Students } from "../../../../../../models/InstituteModel/students.model";
import { InstituteLeaderboard as InstituteLeaderboardModel } from "../../../../../../models/InstituteModel/leaderboard.model";
import { InstituteLeaderboardService } from "../../../../../../services/InstituteService/leaderboard.service";


const InstituteLeaderboard: FC = () => {
  const [leaderboard, setLeaderboard] = useState<InstituteLeaderboardModel>({});
  const { state }: { state: Students } = useLocation();
  const [loading, setLoading] = useState<boolean>(true);

  const fetchLeaderboardData = () => {    
    if (state?.id)
      InstituteLeaderboardService?.fetchLeaderboardData(
        state?.id,
        (data) => {
          setLeaderboard(data);
        },
        () => { },
        () => {  setLoading(false)}
      );
  };
  
  useEffect(() => {
    fetchLeaderboardData();
  }, [state]);

  return (
    <div className="institute-leaderboard">
      <div className="institute-leaderboard__header">
        <RankBoard data={leaderboard} loading={loading}/>
        <CurrentStudentRank data={leaderboard} loading={loading} />
      </div>

      <PointsHistory data={leaderboard} loading={loading}/>
    </div>
  );
};

export default InstituteLeaderboard;
